module.exports = "https://static.wmbcdn.com/uniweb/images/c4e4e415a80559ed77460e8e3134825f.svg";